<template>
  <div cds-layout="horizontal gap:md align@md:right align@lg:center" style="height: 100%">
    <PersonDecider/>
    <div>
      <img style="padding-top: 10px; height: 400px" src="@/assets/Workstation.png">
    </div>
  </div>
</template>

<script>
import PersonDecider from '@/components/PersonDecider.vue'

export default {
  name: 'HomeView',
  components: {
    PersonDecider
  }
}
</script>
